import { InvoicePaymentMethodEnum } from '@ztechapps/totalmilk-payme.contract'

export const PaymentMethodConstant = {
  creditCard: {
    value: InvoicePaymentMethodEnum.creditCard,
    icon: 'credit-card',
  },
  achCreditTransfer: {
    value: InvoicePaymentMethodEnum.achCreditTransfer,
    icon: 'building-columns',
  },
  cash: {
    value: InvoicePaymentMethodEnum.cash,
    icon: 'hand-holding-dollar',
  },
  check: {
    value: InvoicePaymentMethodEnum.check,
    icon: 'money-check-dollar',
  },
}
